import { Component, OnInit, ViewChild } from '@angular/core';
import { jqxLoaderComponent } from 'jqwidgets-ng/jqxloader';
import { jqxTreeComponent } from 'jqwidgets-ng/jqxtree';
import { CrudService } from 'src/app/services/crud/crud.service';
import { MenuService } from 'src/app/services/menu/menu.service';
import { PermisoModel, RolMenuOpcionesModel, RolMenuOpcionesPermisosModel }
    from 'src/app/services/sso/models/rol.menu.opciones.model';
import { RolModel } from 'src/app/services/sso/models/rol.model';
import { JqWidgets } from 'src/app/utils/jqWidgets';
import { environment } from 'src/environments/environment';
import { MainComponent } from '../../main/main.component';
import { NzModalService } from 'ng-zorro-antd/modal';
import { jqxCheckBoxComponent } from 'jqwidgets-ng/jqxcheckbox';
import { jqxDropDownListComponent } from 'jqwidgets-ng/jqxdropdownlist';
import { AplicacionModel } from 'src/app/services/sso/models/aplicacion.model';
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid';
import { ApartadoModel } from 'src/app/services/sso/models/apartado.model';
import { jqxButtonComponent } from 'jqwidgets-ng/jqxbuttons';

@Component({
    selector: 'app-user-options',
    templateUrl: './user-options.component.html',
    styleUrls: ['./user-options.component.css']
})
export class UserOptionsComponent implements OnInit {
    public environment = environment;
    @ViewChild('loader') loader: jqxLoaderComponent;
    @ViewChild('treeMenu') treeMenu: jqxTreeComponent;
    @ViewChild('gridRol') gridRol: jqxTreeComponent;
    @ViewChild('checkAll') checkAll: jqxCheckBoxComponent;
    @ViewChild('cbAplicaciones') cbAplicaciones: jqxDropDownListComponent;
    @ViewChild('cbMenusApp') cbMenusApp: jqxDropDownListComponent;
    @ViewChild('gridPermisos') gridPermisos: jqxGridComponent;
    @ViewChild('gridPermisosGenerales') gridPermisosGenerales: jqxGridComponent;
    @ViewChild('gridApartados') gridApartados: jqxGridComponent;
    @ViewChild('btGuardar') btGuardar: jqxButtonComponent;

    public dataSourceMenu: any;
    public dataAdapterMenu: any;
    private menus: any[] = [];
    public recordsRoles: any;
    public componentRef: UserOptionsComponent;
    public dataSourceRoles: any;
    public dataAdapterRoles: any;
    public dataSourcePermisos: any;
    public dataAdapterPermisos: any;
    public roles: RolModel[] = [];
    public rolSelect: RolModel = new RolModel();
    public rolOptions: RolMenuOpcionesModel[] = [];
    private timerMenu: any = null;
    private haveChanges = false;
    private menuIndexSelect = 0;
    private apps: AplicacionModel[] = [];
    private idsMenuSelecOri = new Map<number, number>();
    private permisosRolApp = new Map<string, RolMenuOpcionesPermisosModel[]>();
    private idAppSelec = 0;
    private permisos: PermisoModel[] = [];
    public opcionOriSelectId: number = 0;
    public opcionSelectId: number = 0;
    public apartadoSelec: ApartadoModel = null;
    public dataSourceApartados: any;
    public dataAdapterApartados: any;
    public apartados: ApartadoModel[] = [];
    public updating = false;
    private menuAppSelec = 0;

    // Preparo las columnas del grid de roles
    public columnsRoles = [
        {
            text: 'Id', columntype: 'textbox', filtertype: 'textbox', datafield: 'id', width: 30, hidden: true
        },
        {
            text: 'Nombre', columntype: 'textbox', filtertype: 'textbox', datafield: 'nombre', width: '100%',
            aggregates: [{
                'Total': function (aggregatedValue, currentValue: number) {
                    return aggregatedValue + 1;
                }
            }],
            aggregatesrenderer: function (aggregates) {
                let renderstring = '';
                if (aggregates["Total"] !== undefined) {
                    renderstring = '<div style="margin-left: 4px;">Total: ' +
                        aggregates["Total"] + '</div>';
                }
                return renderstring;
            }
        },
        //{ text: 'Observaciones', columntype: 'textbox', filtertype: 'textbox', datafield: 'observ', width: '60%' }
    ];

    // Preparo las columnas del grid de permisos
    public columnsPermisos = [
        { text: 'Id', columntype: 'textbox', filtertype: 'textbox', datafield: 'id', width: 30, hidden: true },
        {
            text: 'Nombre', columntype: 'textbox', filtertype: 'textbox', datafield: 'nombre', width: '30%',
            aggregates: [{
                'Total': function (aggregatedValue, currentValue: number) {
                    return aggregatedValue + 1;
                }
            }],
            aggregatesrenderer: function (aggregates) {
                let renderstring = '';
                if (aggregates["Total"] !== undefined) {
                    renderstring = '<div style="margin-left: 4px;">Total: ' +
                        aggregates["Total"] + '</div>';
                }
                return renderstring;
            }
        },
        { text: 'Acronimo', columntype: 'textbox', filtertype: 'textbox', datafield: 'acronimo', width: '20%' },
        { text: 'Descripcion', columntype: 'textbox', filtertype: 'textbox', datafield: 'descripcion', width: '50%' }
    ];

    // Preparo las columnas del grid de apartados
    public columnsApartados = [
        { text: 'Id', columntype: 'textbox', filtertype: 'textbox', datafield: 'id', width: 10, hidden: true },
        { text: 'IdMenuOpcion', columntype: 'textbox', filtertype: 'textbox', datafield: 'idMenuOpcion', width: 10, hidden: true },
        { text: 'Subapartado', columntype: 'textbox', filtertype: 'textbox', datafield: 'subapartado', width: 100 },
        {
            text: 'Nombre', columntype: 'textbox', filtertype: 'textbox', datafield: 'nombre', width: 200,
            aggregates: [{
                'Total': function (aggregatedValue, currentValue: number) {
                    return aggregatedValue + 1;
                }
            }],
            aggregatesrenderer: function (aggregates) {
                let renderstring = '';
                if (aggregates["Total"] !== undefined) {
                    renderstring = '<div style="margin-left: 4px;">Total: ' +
                        aggregates["Total"] + '</div>';
                }
                return renderstring;
            }
        },
        { text: 'Acrónimo', columntype: 'textbox', filtertype: 'textbox', datafield: 'acronimo', width: 120, },
        { text: 'Observaciones', columntype: 'textbox', filtertype: 'textbox', datafield: 'observaciones', width: 400 }
    ];


    //  Esto es para que los textos en los controles del grid salgan en español
    public langGrid = JqWidgets.getLocalization('es');

    constructor(
        private menuService: MenuService,
        private crudService: CrudService,
        private modal: NzModalService) {
    }

    ngOnInit(): void {
    }

    async ngAfterViewInit() {
        this.loader.open();
        this.roles = await this.crudService.getRoles();
        this.initRoles();
        this.menus = await this.menuService.getMenus();
        this.permisos = await this.crudService.getPermisos();
        this.initPermisos();
        this.loader.close();
    }

    // Este método es llamado por el creador del componente
    public init(componentRef: any): void {
        this.componentRef = componentRef;
    }

    // Rellena la lista de roles
    private initRoles() {
        try {
            if (this.roles) {
                this.dataSourceRoles = {
                    datatype: 'json',
                    datafields: [
                        { name: 'id', type: 'number', map: 'Id' },
                        { name: 'nombre', type: 'string', map: 'Nombre' },
                        //{ name: 'observ', type: 'string', map: 'Observaciones' }
                    ],
                    localdata: this.roles,
                    sortcolumn: 'nombre',
                    sortdirection: 'asc'
                }
                this.dataAdapterRoles = new jqx.dataAdapter(this.dataSourceRoles);
            }
        } catch (e) {
            console.log(e);
        }
    }

    // Rellena la lista de permisos
    private initPermisos() {
        try {
            if (this.permisos) {
                this.dataSourcePermisos = {
                    datatype: 'json',
                    datafields: [
                        { name: 'id', type: 'number', map: 'Id' },
                        { name: 'nombre', type: 'string', map: 'Nombre' },
                        { name: 'acronimo', type: 'string', map: 'Acronimo' },
                        { name: 'descripcion', type: 'string', map: 'Descripcion' },
                    ],
                    localdata: this.permisos,
                    sortcolumn: 'nombre',
                    sortdirection: 'asc'
                }
                this.dataAdapterPermisos = new jqx.dataAdapter(this.dataSourcePermisos);
            }
        } catch (e) {
            console.log(e);
        }
    }

    // Rellena el menú
    public initMenu(): void {
        this.treeMenu.clear();
        this.dataSourceMenu = {
            datatype: 'json',
            datafields:
                [
                    { name: 'Id', type: 'string', map: 'Id' },
                    { name: 'PadreId', type: 'string', map: 'PadreId' },
                    { name: 'TextoId', type: 'string', map: 'TextoId' },
                    { name: 'Orden', type: 'string', map: 'Orden' },
                    { name: 'AccionId', type: 'string', map: 'AccionId' }
                ],
            id: 'Id',
            localdata: this.menus[this.menuIndexSelect].Opciones
        };
        this.dataAdapterMenu = new jqx.dataAdapter(this.dataSourceMenu, { autoBind: true });
        this.recordsRoles = this.dataAdapterMenu.getRecordsHierarchy('Id', 'PadreId', 'items',
            [
                { name: 'Id', map: 'id' },
                { name: 'TextoId', map: 'label' },
                { name: 'AccionId', map: 'value' }
            ]);
        if (!this.recordsRoles) {
            this.recordsRoles = [];
        }
        // Almaceno en una hash la relación entre el id de la opcion del menú seleccionado con el id
        // de la opción original del menú base
        this.idsMenuSelecOri.clear();
        this.menus[this.menuIndexSelect].Opciones.forEach(opc => {
            this.idsMenuSelecOri.set(opc.Id, opc.OpcionOriginalId);
        });
    }

    // Al seleccionar un Rol
    public async onRolSelect(event: any): Promise<void> {
        if (this.haveChanges) {
            this.haveChanges = false;
            await this.onSave();
        }
        this.opcionOriSelectId = 0;
        this.opcionSelectId = 0;
        this.apartadoSelec = null;
        this.rolSelect = this.roles[event.args.rowindex];
        this.loader.open();

        if (this.cbAplicaciones) {
            this.cbAplicaciones.clear();
            this.cbMenusApp.clear();
            this.treeMenu.clear();
            this.btGuardar.disabled(true);
            this.btGuardar.disabled(true);
        } else {
            if (this.btGuardar) {
                this.btGuardar.disabled(false);
            }
        }
        // Recupero las aplicaciones del rol seleccionado
        this.apps = await this.crudService.getAppsRoles(this.rolSelect.Id);
        this.cbAplicaciones.clear();
        let is = -1;
        if (!this.apps || this.apps.length < 1) {
            // Si no se han definido aplicaciones pongo *todas*
            // this.cbAplicaciones.addItem({ label: 'Todas las aplicaciones', value: 0 });
            // is = 0;
            // this.apps = await this.crudService.getApps();
        }
        // Ordeno por nombre de aplicación
        this.apps.sort((a, b) => {
            return a.Nombre.localeCompare(b.Nombre);
        });
        if (this.apps && this.apps.length > 0) {
            let i = 0;
            this.apps.forEach((app) => {
                if (app.Id != 9) { // EcoMaestro se excluye de la lista
                    this.cbAplicaciones.addItem({ label: app.Nombre, value: app.Id });
                    if (app.Id === 1 && is < 0) { // EcoSAT
                        is = i;
                    }
                    i++;
                }
            });
        }
        this.cbAplicaciones.selectIndex(is > -1 ? is : 0);
        this.loader.close();
    }

    // Al seleccionar una opción del menú
    public onMenuSelect(event: any) {
        const args = event.args;
        const item: any = this.treeMenu.getItem(args.element);
        this.apartadoSelec = new ApartadoModel();
        if (item) {
            if (this.menus[this.menuIndexSelect].Opciones && this.menus[this.menuIndexSelect].Opciones.length > 0) {
                for (let i = 0; i < this.menus[this.menuIndexSelect].Opciones.length; i++) {
                    if (item.id === ('' + this.menus[this.menuIndexSelect].Opciones[i].Id)) {
                        if (!item.hasItems && item.checked) {
                            this.opcionOriSelectId = this.menus[this.menuIndexSelect].Opciones[i].OpcionOriginalId;
                            this.opcionSelectId = this.menus[this.menuIndexSelect].Opciones[i].Id;
                            // Muestro los permisos generales
                            this.showPermissions(this.apartadoSelec.Id, this.permisosRolApp.get(this.opcionOriSelectId + "-" +
                                this.apartadoSelec.Id));
                            // Recupero los apartados de la opción
                            this.getApartados(this.opcionOriSelectId);
                            return;
                        }
                        this.opcionOriSelectId = 0;
                        this.opcionSelectId = 0;
                        break;
                    }
                }
            }
        }
    }

    // Al chequear/deschequear una opción del menú
    public onMenuChange(event: any) {
        if (!this.timerMenu && !this.updating) {
            this.timerMenu = setTimeout(() => {
                const args = event.args;
                const item: any = this.treeMenu.getItem(args.element);
                if (item) {
                    this.haveChanges = true;
                    this.onMenuSelect(event);
                    this.checkSubItemsTree(item, item.checked);
                    this.checkParentItemsTree(item, item.checked);
                }
                clearTimeout(this.timerMenu);
                this.timerMenu = null;
            }, 250);
        }
    }

    // Chequea todos los items que están por debajo de acuerdo al estado del item actual
    private checkSubItemsTree(item: any, check: boolean): any {
        const level = item.level;
        while (item.nextItem && item.nextItem.level > level) {
            this.treeMenu.checkItem(item.nextItem, check);
            item = item.nextItem;
        }
    }

    // Chequea todos los items que están por arriba de acuerdo al estado del item actual
    private checkParentItemsTree(item: any, check: boolean): any {
        let level = item.level;
        let flag = false;
        let flag2 = false;
        const itemOri = item;
        while (item.nextItem && item.nextItem.level >= level - 1) {
            item = item.nextItem;
            if (item.checked) {
                if (item.level >= level)
                    flag = true;
                else {
                    flag2 = true;
                    break;
                }
            }
        }
        item = itemOri;
        while (item.prevItem && item.prevItem.level > -1) {
            if (item.prevItem.level < level) {
                level--;
                if (check)
                    this.treeMenu.checkItem(item.prevItem, check);
                else {
                    if (item.prevItem.level < itemOri.level - 1) {
                        this.treeMenu.checkItem(item.prevItem, flag2 || flag);
                        break;
                    }
                    else
                        this.treeMenu.checkItem(item.prevItem, flag);
                }
            }
            item = item.prevItem;
            if (item.checked)
                flag = true;
            if (item.level < 1) {
                break;
            }
        }
    }

    // Al seleccionar un apartado
    public async onApartadoSelect(event: any) {
        this.apartadoSelec = this.apartados[event.args.rowindex];
        this.loader.open();
        if (!this.apartadoSelec) {
            this.apartadoSelec = new ApartadoModel();
        }
        this.showPermissions(this.apartadoSelec.Id, this.permisosRolApp.get(this.opcionOriSelectId + "-" + this.apartadoSelec.Id));
        this.loader.close();
    }

    async getApartados(opcionId: number) {
        try {
            this.loader.open();
            this.apartados = [];
            this.apartados = await this.menuService.getApartados(opcionId);
            const t = setTimeout(() => {
                clearTimeout(t);
                if (this.apartados && this.apartados.length > 0) {
                    this.gridApartados.clearselection();
                    this.dataSourceApartados = {
                        datatype: 'json',
                        datafields:
                            [
                                { name: 'id', type: 'string', map: 'Id' },
                                { name: 'idMenuOpcion', type: 'string', map: 'IdMenuOpcion' },
                                { name: 'acronimo', type: 'string', map: 'Acronimo' },
                                { name: 'nombre', type: 'string', map: 'Nombre' },
                                { name: 'subapartado', type: 'string', map: 'SubApartado' },
                                { name: 'observaciones', type: 'string', map: 'Observaciones' }
                            ],
                        id: 'Id',
                        localdata: this.apartados,
                        sortcolumn: 'subapartado',
                        sortdirection: 'asc'
                    };
                    this.dataAdapterApartados = new jqx.dataAdapter(
                        this.dataSourceApartados,
                        {
                            autoBind: true
                        });
                }
                this.loader.close();
            }, 500);
        } catch (e) {
            console.log(e);
        }
    }

    // Muestra los permisos de la opción seleccionada
    private showPermissions(apartado: number, permisos: RolMenuOpcionesPermisosModel[]) {
        this.updating = true;
        const t = setTimeout(() => {
            clearTimeout(t);
            if (apartado < 1) {
                // Permisos generales
                this.gridPermisosGenerales.clearselection();
                if (permisos && permisos.length > 0) {
                    const rows = this.gridPermisosGenerales.getrows();
                    if (rows && rows.length > 0) {
                        rows.forEach(row => {
                            permisos.forEach(p => {
                                if (p.IdApartado == 0 && p.IdPermiso === row.id) {
                                    this.gridPermisosGenerales.selectrow(row.boundindex);
                                }
                            });
                        });
                    }
                }
            } else {
                // Permisos por apartado
                this.gridPermisos.clearselection();
                if (permisos && permisos.length > 0) {
                    const rows = this.gridPermisos.getrows();
                    if (rows && rows.length > 0) {
                        rows.forEach(row => {
                            permisos.forEach(p => {
                                if (p.IdApartado == apartado && p.IdPermiso === row.id) {
                                    this.gridPermisos.selectrow(row.boundindex);
                                }
                            });
                        });
                    }
                }
            }
            this.updating = false;
        }, 500);
    }

    public onPermisoSelect(event: any, checked: boolean, generales: boolean) {
        const apartadoId = generales ? 0 : this.apartadoSelec.Id;
        if (this.opcionOriSelectId > 0 && !this.updating) {
            this.haveChanges = true;
            // Compruebo si se han seleccionado/deseleccionado todos
            if (event.args.rowindex instanceof Array) {
                if (event.args.rowindex.length > 0) {
                    const permisosOpc = [];
                    this.permisos.forEach(permiso => {
                        const newPerm = new RolMenuOpcionesPermisosModel();
                        newPerm.Id = 0;
                        newPerm.IdMenuOpcionRol = 0;
                        newPerm.IdPermiso = permiso.Id;
                        newPerm.IdMenuOpcion = this.opcionOriSelectId;
                        newPerm.IdApartado = apartadoId;
                        newPerm.Acronimo = permiso.Acronimo;
                        permisosOpc.push(newPerm);
                    });
                    this.permisosRolApp.set(this.opcionOriSelectId + "-" + apartadoId, permisosOpc);

                    this.idsMenuSelecOri.set(this.opcionOriSelectId, this.opcionOriSelectId);
                } else {
                    this.permisosRolApp.set(this.opcionOriSelectId + "-" + apartadoId, []);
                }
            } else {
                const permisoSelect = this.permisos[event.args.rowindex];
                let permisosOpc = this.permisosRolApp.get(this.opcionOriSelectId + "-" + apartadoId);
                if (permisoSelect) {
                    if (!permisosOpc) {
                        permisosOpc = [];
                    }
                    for (let i = 0; i < permisosOpc.length; i++) {
                        if (permisosOpc[i].IdPermiso === permisoSelect.Id) {
                            if (!checked) {
                                permisosOpc.splice(i, 1);
                                this.permisosRolApp.set(this.opcionOriSelectId + "-" + apartadoId, permisosOpc);
                            }
                            return;
                        }
                    }
                    const newPerm = new RolMenuOpcionesPermisosModel();
                    newPerm.Id = 0;
                    newPerm.IdMenuOpcionRol = 0;
                    newPerm.IdPermiso = permisoSelect.Id;
                    newPerm.IdMenuOpcion = this.opcionOriSelectId;
                    newPerm.IdApartado = apartadoId;
                    newPerm.Acronimo = permisoSelect.Acronimo;
                    permisosOpc.push(newPerm);
                    this.permisosRolApp.set(this.opcionOriSelectId + "-" + apartadoId, permisosOpc);

                    this.idsMenuSelecOri.set(this.opcionOriSelectId, this.opcionOriSelectId);
                }
            }
        }
    }

    // Al seleccionar una aplicación
    public async onChangeAplicacion(event: any, menuId = 0) {
        if (this.haveChanges) {
            this.haveChanges = false;
            await this.onSave();
        }
        this.updating = true;
        this.idAppSelec = menuId === 0 ? event.args.item.value : event;
        this.loader.open();
        this.apartadoSelec = new ApartadoModel();
        this.opcionOriSelectId = 0;

        // Obtengo las opciones del menú de la aplicación seleccionada
        if (this.idAppSelec > 0) {
            let menu;
            if (menuId < 1) {
                // Recupero el menú de la aplicación con todas las opciones de los módulos que se 
                // hayan definido para cualquier empresa que tenga la aplicación
                menu = await this.menuService.getMenuAppCompleto(this.idAppSelec);
                // Si no hay un menú para la aplicación cojo el menú base
                if (!menu) {
                    //menu = { ...this.menus[0] };
                    this.cbMenusApp.clear();
                    this.treeMenu.uncheckAll();
                    this.checkAll.disabled(true);
                    this.treeMenu.disabled(true);
                    this.btGuardar.disabled(true);
                    this.loader.close();
                    return;
                }
            } else {
                // Recupero el menú de la aplicación con todas las opciones de los módulos que se 
                // hayan definido para cualquier empresa que tenga el menu
                menu = await this.menuService.getMenuCompleto(menuId);
                // menu = { ...this.menus.find(x => x.Id === menuId) };
            }
            // Selecciono el menú de entre toda la lista de menús
            for (let i = 0; i < this.menus.length; i++) {
                if (menu.Id === this.menus[i].Id) {
                    this.menuIndexSelect = i;
                    this.menus[i] = menu;
                    break;
                }
            }
        } else {
            // Selecciono el menú base
            this.menuIndexSelect = 0;
            this.menuAppSelec = 0;
        }

        this.checkAll.disabled(false);
        this.treeMenu.disabled(false);
        this.btGuardar.disabled(false);

        if (menuId < 1) {
            // Relleno el combo de menús de aplicaciones
            const ma = new Map<number, number>();
            const menusApp = await this.menuService.getMenusApp();
            const menusAppEmp = await this.menuService.getMenusAppEmp();
            this.cbMenusApp.clear();
            if (menusApp && menusApp.length > 0) {
                menusApp.forEach(menu => {
                    if (!ma.has(menu.MenuId) && menu.AplicacionId === this.idAppSelec) {
                        ma.set(menu.MenuId, menu.MenuId);
                        const m = this.menus.find(x => x.Id === menu.MenuId);
                        this.cbMenusApp.addItem({ label: m.Nombre, value: menu.MenuId });
                    }
                });
            }

            if (menusAppEmp && menusAppEmp.length > 0) {
                menusAppEmp.forEach(menu => {
                    if (!ma.has(menu.MenuId) && menu.AplicacionId === this.idAppSelec) {
                        ma.set(menu.MenuId, menu.MenuId);
                        const m = this.menus.find(x => x.Id === menu.MenuId);
                        this.cbMenusApp.addItem({ label: m.Nombre, value: menu.MenuId });
                    }
                });
            }

            this.cbMenusApp.selectIndex(0);
        }

        this.refreshOptions();

        this.updating = false;
        this.loader.close();
    }

    public onChangeMenu(event: any) {
        this.menuAppSelec = event.args.item.value;
        if (!this.updating) {
            this.onChangeAplicacion(this.idAppSelec, this.menuAppSelec);
        }
    }

    public async onSave(): Promise<void> {
        if (!this.rolSelect) {
            MainComponent.showError('ATENCIÓN', 'Seleccione un Rol de la lista', 2000);
            return;
        }
        return new Promise(resolve => {
            this.modal.confirm({
                nzTitle: '<i>ATENCION</i>',
                nzContent: 'Quiere guardar los cambios ?',
                nzCentered: true,
                nzCancelText: 'NO',
                nzOkText: 'SI',
                nzOnOk: async () => {
                    const rolOptions: RolMenuOpcionesModel[] = [];
                    const items: any = this.treeMenu.getCheckedItems();
                    if (items) {
                        items.forEach(option => {
                            const ro: RolMenuOpcionesModel = new RolMenuOpcionesModel();
                            ro.IdRol = this.rolSelect.Id;
                            ro.IdMenuOpciones = this.idsMenuSelecOri.get(Number.parseInt(option.id));
                            ro.IdAplicacion = this.idAppSelec;
                            ro.IdMenu = this.menuAppSelec;
                            ro.Permisos = [];
                            for (const [key, value] of this.permisosRolApp) {
                                value.forEach(permiso => {
                                    //if (permiso.IdMenuOpcion == ro.IdMenuOpciones) {
                                    const idOri = this.idsMenuSelecOri.get(permiso.IdMenuOpcion);
                                    if (idOri === ro.IdMenuOpciones) {
                                        ro.Permisos.push(permiso);
                                    }
                                })
                            }
                            rolOptions.push(ro);
                        });
                    }
                    // Si no hay items creo uno con el id del rol para que se borren todas las opciones del mismo
                    if (rolOptions.length < 1) {
                        const ro: RolMenuOpcionesModel = new RolMenuOpcionesModel();
                        ro.IdRol = this.rolSelect.Id;
                        ro.IdMenuOpciones = 0;
                        ro.IdAplicacion = this.idAppSelec;
                        ro.IdMenu = this.menuAppSelec;
                        rolOptions.push(ro);
                    }
                    const result = await this.crudService.saveMenuOptionsRol(rolOptions);
                    if (result) {
                        MainComponent.showSuccess('ATENCIÓN', 'Registro almacenado', 2000);
                    } else {
                        MainComponent.showError('ATENCIÓN', 'Algo ha ido mal', 2000);
                    }
                    this.haveChanges = false;
                    resolve();
                },
                nzOnCancel: async () => {
                    resolve();
                }
            });
        });
    }

    private async refreshOptions() {
        // Cargo las opciones del menú seleccionado
        this.rolOptions = [];
        this.initMenu();
        // Obtengo las opciones del menú del rol seleccionado
        const rolOptions = await this.crudService.getMenuOptionsRol(this.rolSelect.Id, this.idAppSelec);
        if (rolOptions) {
            rolOptions.forEach(ro => {
                if (ro.IdMenu === this.menuAppSelec) {
                    this.rolOptions.push(ro);
                }
            });
        }

        this.permisosRolApp.clear();
        if (this.rolOptions && this.rolOptions.length > 0) {
            this.rolOptions.forEach(opc => {
                if (opc.Permisos && opc.Permisos.length > 0) {
                    opc.Permisos.forEach(permiso => {
                        this.permisosRolApp.set(opc.IdMenuOpciones + "-" + permiso.IdApartado, opc.Permisos);
                    });
                }
            });
        }
        // Chequeo las opciones del menú del rol seleccionado
        if (this.checkAll.checked()) {
            this.checkAll.checked(false);
        } else {
            this.treeMenu.uncheckAll();
        }

        const opcionesSelec = new Map<number, number>();
        const treeMenu = this.treeMenu.getItems();
        treeMenu.forEach((item: any) => {
            // Busco el id de la opción original
            if (this.rolOptions.find(x => x.IdMenuOpciones === this.idsMenuSelecOri.get(Number.parseInt(item.id)))) {
                // Compruebo si es un item de nivel 0 o en caso contrario si el padre está chequeado
                if (item.parentId === 0 || opcionesSelec.has(item.parentId)) {
                    this.treeMenu.checkItem(item, true);
                    opcionesSelec.set(item.id, item.id);
                }
            }
        });
    }

    public onCheckAll(event: any): void {
        if (event.args.checked) {
            this.treeMenu.checkAll();
            this.haveChanges = true;
        } else {
            this.treeMenu.uncheckAll();
        }
    }

}
